var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-switch',{staticClass:"pa-0 ma-0 switch-mock",attrs:{"color":"accent","inset":"","hide-details":""},model:{value:(_vm.state),callback:function ($$v) {_vm.state=$$v},expression:"state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }